export const environment = {
    environment_name: 'production',
    prod:true,
    entity_service_url: "https://entity-service-srjal6lxda-uc.a.run.app",
    file_service_url: "https://boardroom-file-service-srjal6lxda-uc.a.run.app",
    translate_transcript_url: "https://boardmeeting-srjal6lxda-uc.a.run.app",
    storage_cdn_url:'https://boardroomstorage.deloitte.com'
}